import { render, staticRenderFns } from "./RankTagChange.vue?vue&type=template&id=1e9a3358&"
import script from "./RankTagChange.vue?vue&type=script&lang=js&"
export * from "./RankTagChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports